import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class ClockedTimeEntriesBus extends BaseBus {
    constructor(busObj: ClockedTimeEntriesBus = null) {
        super(busObj);
        if (busObj && busObj.startTime) { this.startTime = DateFunctions.getDate(busObj.startTime); }
        if (busObj && busObj.endTime) { this.endTime = DateFunctions.getDate(busObj.endTime); }
    }
    setId(id: any) {
        this.timeEntryId = id;
    }
    setParentId(id: any) {
        // this.timeOffRequestId = id;
    }
    CID(): any {
        return this.timeEntryId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {

    }
    setFromForm(data: ClockedTimeEntriesBus) {
        super.setFromForm(data);
        if (data && data.startTime) { this.startTime = DateFunctions.getDate(data.startTime); }
        if (data && data.endTime) { this.endTime = DateFunctions.getDate(data.endTime); }
        let dateNow = CommonFunctions.getDateNow();
    }
    setBeforeSave() {
        if ( this.startTime) { this.startTime = DateFunctions.getDateTimeWithUTCOffset(this.startTime); }
        if (this.endTime) { this.endTime = DateFunctions.getDateTimeWithUTCOffset(this.endTime); }
    }
    timeEntryId: any;
    personId: any;
    companyId: any;
    payTypeId: any;
    timeTypeId: any;
    startTime: Date;
    endTime: Date;
    dispatchId: any;
    notes: string;
    insertDt: Date;
    updateDt: Date;
    insertUserId: any;
    updateUserId: any;
    timeTypeName: string;
    payTypeName: string;
    empNo: string;
    mgrApproved: boolean;
    resourceName: string;
    aprvdName: boolean;
    createName: boolean;
    hours(): number {
        return DateFunctions.dateDiffHours(this.startTime, this.endTime);
    }
}
